class Wishlist {
  constructor() {
    this.storageKey = 'shopify-wishlist';
    this.elements = {
      container: document.querySelector('[data-wishlist]'),
      grid: document.querySelector('[data-wishlist-grid]'),
      empty: document.querySelector('[data-wishlist-empty]'),
      sort: document.querySelector('[data-wishlist-sort]'),
      count: document.querySelectorAll('[data-wishlist-count]'),
      controls: document.querySelector('[data-wishlist-controls]'),
      header: document.querySelector('[data-wishlist-header]'),
      shareSection: document.querySelector('[data-wishlist-share]'),
      shareButtons: document.querySelectorAll('[data-share]')
    };
    
    this.init();
  }

  init() {
    this.bindEvents();
    if (this.elements.grid) {
      this.renderWishlist();
    }
    this.updateWishlistButtons();
    this.updateWishlistCount();
    this.bindShareEvents();
    this.updateShareVisibility();
  }

  bindEvents() {
    document.addEventListener('click', (event) => {
      const wishlistButton = event.target.closest('[data-wishlist-button]');
      
      if (wishlistButton) {
        event.preventDefault();
        const productCard = wishlistButton.closest('.product-card');
        this.toggleWishlistItem(wishlistButton, productCard);
      }
    });

    this.elements.sort?.addEventListener('change', () => this.renderWishlist());
  }

  bindShareEvents() {
    if (!this.elements.shareButtons) return;

    this.elements.shareButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        const shareType = button.getAttribute('data-share');
        this.handleShare(shareType, button);
      });
    });
  }

  async removeWithAnimation(productCard) {
    if (!productCard) return;
    
    productCard.classList.add('removing');
    
    await new Promise(resolve => setTimeout(resolve, 300));
    
    productCard.remove();
    
    const wishlist = this.getWishlist();
    if (wishlist.length === 0) {
      if (this.elements.empty) {
        this.elements.empty.style.display = 'block';
      }
      if (this.elements.header) {
        this.elements.header.style.display = 'none';
      }
      if (this.elements.shareSection) {
        this.elements.shareSection.classList.remove('is-visible');
      }
    }
  }

  handleShare(shareType, button) {
    const currentUrl = window.location.href;
    const shareText = "Check out my wishlist from Nine6ixe";

    switch (shareType) {
      case 'email':
        const emailSubject = 'Nine6ixe Wishlist';
        const emailBody = `${shareText}\n\n${currentUrl}`;
        window.location.href = `mailto:?subject=${encodeURIComponent(emailSubject)}&body=${encodeURIComponent(emailBody)}`;
        break;

      case 'copy':
        navigator.clipboard.writeText(currentUrl).then(() => {
          // Créer ou mettre à jour le tooltip
          let tooltip = button.querySelector('.tooltip');
          if (!tooltip) {
            tooltip = document.createElement('div');
            tooltip.className = 'tooltip';
            tooltip.textContent = 'Link copied!';
            button.appendChild(tooltip);
          }
          
          // Afficher le tooltip
          button.classList.add('show-tooltip');
          
          // Cacher le tooltip après 2 secondes
          setTimeout(() => {
            button.classList.remove('show-tooltip');
          }, 2000);
        });
        break;
    }
  }

  getWishlist() {
    try {
      const wishlist = localStorage.getItem(this.storageKey);
      return wishlist ? JSON.parse(wishlist) : [];
    } catch (error) {
      console.error('Error getting wishlist:', error);
      return [];
    }
  }

  setWishlist(wishlist) {
    try {
      localStorage.setItem(this.storageKey, JSON.stringify(wishlist));
      this.updateWishlistButtons();
      this.updateWishlistCount();
      this.updateShareVisibility();
      if (this.elements.grid) {
        this.renderWishlist();
      }
    } catch (error) {
      console.error('Error saving wishlist:', error);
    }
  }

  toggleWishlistItem(button, productCard = null) {
    const productId = button.dataset.productId;
    const wishlist = this.getWishlist();
    const existingIndex = wishlist.findIndex(item => item.id === productId);

    if (existingIndex > -1) {
      wishlist.splice(existingIndex, 1);
      button.classList.remove('is-active');
      
      if (this.elements.grid && productCard) {
        this.removeWithAnimation(productCard);
      }
    } else {
      const product = {
        id: productId,
        handle: button.dataset.productHandle,
        title: button.dataset.productTitle,
        image: button.dataset.productImage,
        price: button.dataset.productPrice,
        url: button.dataset.productUrl,
        variant_id: button.dataset.variantId || productId,
        addedAt: new Date().toISOString()
      };
      wishlist.push(product);
      button.classList.add('is-active');
    }

    this.setWishlist(wishlist);
  }

  updateWishlistButtons() {
    const wishlist = this.getWishlist();
    const buttons = document.querySelectorAll('[data-wishlist-button]');

    buttons.forEach(button => {
      const productId = button.dataset.productId;
      const isInWishlist = wishlist.some(item => item.id === productId);
      button.classList.toggle('is-active', isInWishlist);
    });
  }

  updateWishlistCount() {
    const count = this.getWishlist().length;
    this.elements.count?.forEach(element => {
      element.textContent = count > 0 ? `${count} item${count !== 1 ? 's' : ''}` : '';
    });

    if (this.elements.sort) {
      this.elements.sort.classList.toggle('hidden', count === 0);
    }

    if (this.elements.empty) {
      this.elements.empty.style.display = count === 0 ? 'block' : 'none';
    }
  }

  updateShareVisibility() {
    const hasItems = this.getWishlist().length > 0;
    if (this.elements.shareSection) {
      if (hasItems) {
        this.elements.shareSection.classList.remove('hidden');
        setTimeout(() => {
          this.elements.shareSection.classList.add('is-visible');
        }, 100);
      } else {
        this.elements.shareSection.classList.remove('is-visible');
        this.elements.shareSection.classList.add('hidden');
      }
    }
  }

  sortWishlist(wishlist) {
    const sortValue = this.elements.sort?.value || 'date-desc';
    
    return [...wishlist].sort((a, b) => {
      switch (sortValue) {
        case 'date-asc':
          return new Date(a.addedAt) - new Date(b.addedAt);
        case 'date-desc':
          return new Date(b.addedAt) - new Date(a.addedAt);
        case 'price-asc':
          return parseFloat(a.price) - parseFloat(b.price);
        case 'price-desc':
          return parseFloat(b.price) - parseFloat(a.price);
        default:
          return 0;
      }
    });
  }

  renderWishlist() {
    if (!this.elements.grid) return;

    const wishlist = this.sortWishlist(this.getWishlist());
    
    if (wishlist.length === 0) {
      this.elements.grid.innerHTML = '';
      if (this.elements.empty) {
        this.elements.empty.style.display = 'block';
      }
      if (this.elements.sort) {
        this.elements.sort.classList.add('hidden');
      }
      if (this.elements.header) {
        this.elements.header.style.display = 'none';
      }
      this.updateShareVisibility();
      return;
    }

    if (this.elements.empty) {
      this.elements.empty.style.display = 'none';
    }
    if (this.elements.sort) {
      this.elements.sort.classList.remove('hidden');
    }
    if (this.elements.header) {
      this.elements.header.style.display = 'flex';
    }

    this.elements.grid.innerHTML = `
      <motion-list class="product-grid card-grid card-grid--5 mobile:card-grid--2 grid">
        ${wishlist.map(item => `
          <div class="card product-card product-card--card flex flex-col leading-none relative overflow-hidden" data-product-id="${item.id}" style="transform: translateY(var(--motion-translateY)); --motion-translateY: 0px; opacity: 1; visibility: visible;">
            <div class="product-card__media relative h-auto">
              <button 
                class="wishlist-btn is-active"
                data-wishlist-button
                data-product-id="${item.id}"
                data-product-handle="${item.handle}"
                data-product-title="${item.title}"
                data-product-image="${item.image}"
                data-product-price="${item.price}"
                data-product-url="${item.url}"
                data-variant-id="${item.variant_id}"
              >
                <span class="wishlist-btn__icon">
                  <svg class="icon icon-heart icon-lg" viewBox="0 0 24 24" stroke="currentColor" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 21C13 21 22 16.0002 22 9.00045C22 5.50058 19 3.04407 16 3.00066C14.5 2.97896 13 3.50067 12 5.00061C11 3.50067 9.47405 3.00067 8 3.00067C5 3.00067 2 5.50058 2 9.00045C2 16.0002 11 21 12 21Z" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                </span>
              </button>
              <div class="badges z-2 absolute grid gap-3 pointer-events-none"></div>
              <a class="block relative media media--square" href="${item.url}" aria-label="${item.title}">
                <img 
                  src="${item.image}"
                  alt="${item.title}"
                  class="w-full h-full object-cover"
                  loading="lazy"
                  width="2048"
                  height="2048"
                >
              </a>
            </div>
            <div class="product-card__content grow flex flex-col justify-start text-left">
              <div class="product-card__details flex flex-col lg:flex-row items-baseline gap-2 w-full">
                <p class="grow">
                  <a class="product-card__title reversed-link text-base-xl font-medium leading-tight" href="${item.url}">${item.title}</a>
                </p>
                <div class="price flex flex-wrap lg:flex-col lg:items-end gap-2 md:gap-1d5">
                  <span class="price__regular whitespace-nowrap">${typeof item.price === 'number' ? `$${item.price.toFixed(2)}` : item.price} CAD</span>
                </div>
              </div>
            </div>
          </div>
        `).join('')}
      </motion-list>
    `;

    this.updateShareVisibility();
    this.bindShareEvents();
  }
}

// Initialize wishlist
if (typeof theme === 'undefined') {
  window.theme = {};
}

theme.Wishlist = new Wishlist();